import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faFilterSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import {
  noResults,
  noResultsDescription,
  noResultsError,
  noResultsIcon,
  noResultsIconSmall,
  noResultsReset,
  noResultsSmall
} from './NoResult.css'

type NoResultProps = {
  icon?: IconProp
  message: string
  description?: string
  onDismiss?: () => void
  dismissLabel?: string
  isSmall?: boolean
  isError?: boolean
}

export const NoResult = ({
  icon = faFilterSlash,
  message,
  description,
  onDismiss,
  dismissLabel,
  isSmall = false,
  isError = false
}: NoResultProps): ReactElement => {
  return (
    <div
      className={clsx(noResults, {
        [noResultsSmall]: isSmall,
        [noResultsError]: isError
      })}
    >
      <div className={clsx(noResultsIcon, { [noResultsIconSmall]: isSmall })}>
        <FontAwesomeIcon icon={icon} />
      </div>
      {message}
      {description && <p className={noResultsDescription}>{description}</p>}
      {onDismiss && dismissLabel && (
        <span className={noResultsReset} onClick={onDismiss}>
          {dismissLabel}
        </span>
      )}
    </div>
  )
}
